import { OnChangeFn, SortingState, Updater } from '@tanstack/react-table';

import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSortingState = (defaultColumnId: string) => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize from URL params or default
  const getInitialState = (): SortingState => {
    try {
      const stateFromUrl = JSON.parse(searchParams.get('sortingState') ?? '[]');
      return stateFromUrl.length > 0
        ? stateFromUrl
        : [{ id: defaultColumnId, desc: true }];
    } catch (e) {
      return [{ id: defaultColumnId, desc: true }];
    }
  };

  const [sortingState, setSortingStateInternal] =
    useState<SortingState>(getInitialState);

  // Handle state updates
  const setSortingState: OnChangeFn<SortingState> = (
    sortingStateUpdater: Updater<SortingState>
  ) => {
    setSortingStateInternal((prevState) => {
      const newState =
        typeof sortingStateUpdater === 'function'
          ? sortingStateUpdater(prevState)
          : sortingStateUpdater;

      if (newState.length === 0) {
        const prevStateId = prevState[0]?.id;
        const newStateId = defaultColumnId;
        const newState = [{ id: newStateId, desc: prevStateId !== newStateId }];
        setSearchParams(
          (prev) => {
            prev.set('sortingState', JSON.stringify(newState));
            return prev;
          },
          { replace: true }
        );
        return newState;
      }
      setSearchParams(
        (prev) => {
          prev.set('sortingState', JSON.stringify(newState));
          return prev;
        },
        { replace: true }
      );
      return newState;
    });
  };

  return [sortingState, setSortingState] as const;
};
